import { cloneDeep, keys, set } from 'lodash';

export const FALLBACK_ATTRIBUTE_VALUE = 'OTHER';

export const traceSpanMetricNormalize = (span, spanFiltersGetter) => {
    const spanFilters = spanFiltersGetter();
    if (!spanFilters) {
        return span;
    }
    const { name, attributes } = span || {};
    const filtersConfig = spanFilters[name];

    if (!filtersConfig) {
        return span;
    }

    const updatedSpan = cloneDeep(span);
    keys(filtersConfig).forEach(key => {
        const allowedValues = filtersConfig[key];
        const originalValue = attributes[key];

        const shouldReplace = !allowedValues?.has(originalValue);

        if (shouldReplace) {
            set(updatedSpan.attributes, key, FALLBACK_ATTRIBUTE_VALUE);
        }
    });

    return updatedSpan;
};
